<template>
  <div>
    <b-form ref="form" @submit.stop.prevent="handleSubmit">
      <p class="lead"><strong>Вопрос <span v-if="questionIndex">{{ questionIndex + 1 }}</span></strong></p>
      <b-form-group label="Вопрос" label-for="title">
        <b-form-textarea
          id="title"
          v-model="question.question"
          placeholder=""
          rows="2"
          max-rows="10">
        </b-form-textarea>
      </b-form-group>

      <b-form-group label="Текст задания" label-for="text">
        <b-form-textarea
          id="text"
          v-model="question.text"
          placeholder=""
          rows="2"
          max-rows="10">
        </b-form-textarea>
      </b-form-group>
      
      <br>

      <p class="lead"><strong>Ответы</strong></p>
      <b-form-group :label="'Вариант ответа ' + (index + 1)" label-for="answer" v-for="(answer, index) in question.answers" :key="index">
        <b-form-textarea
          :id="answer"
          v-model="question.answers[index]"
          placeholder=""
          rows="1"
          max-rows="10"
          :class="{'bg-light-green': question.answer.includes(index) && question.answer.length }"
        ></b-form-textarea>
      </b-form-group>

      <p><a href="#" class="btn btn-light" @click.prevent="question.answers.push('')"><img src="/static/images/icons/plus.svg" alt=""> Добавить ответ</a></p>

      <b-form-group
        label="Правильный вариант ответа"
        v-slot="{ ariaDescribedby }"
        class="w-100"
      >
        <b-form-checkbox-group
          v-model="question.answer"
          :options="allAnswers"
          :aria-describedby="ariaDescribedby"
          name="flavour-1a"
          stacked
          class="mb-3"
        ></b-form-checkbox-group>
      </b-form-group>

      <b-button type="submit" variant="primary">Сохранить</b-button>
    </b-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { slugify } from '@/services/utils'

export default {
  props: ['item', 'editQuestion', 'subjectSlug', 'editQuestionIndex'],
  data () {
    return {
      variant: {
        title: '',
        slug: '',
        createdAt: '',
        isActive: true,
        description: '',
        questions: []
      },
      question: {
        text: '',
        question: '',
        answers: [],
        answer: []
      },
      questionIndex: null
    }
  },
  computed: {
    ...mapState({
      statusOptions: state => state.auth.statusOptions
    }),
    slug () {
      return slugify(this.item.title)
    },
    title () {
      if (this.item) {
        return 'Редактировать вопрос'
      } else {
        return 'Добавить вопрос'
      }
    },
    allAnswers () {
      return this.question.answers.map((answer, index) => {
        return { value: index, text: '(' + (index + 1) + ') ' + answer }
      })
    }
  },
  methods: {
    checkFormValidity () {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid ? 'valid' : 'invalid'
      return valid
    },
    handleSubmit () {
      const { variant, subjectSlug, question } = this
      this.variant.slug = this.item.slug

      if (this.editQuestion) {
        let questions = [...this.item.questions]
        this.variant.questions[this.questionIndex] = {...questions[this.questionIndex], question: this.question.question, answers: this.question.answers, answer: this.question.answer, text: this.question.text}
        console.log(variant)

        this.$store.dispatch('UPDATE_SUBJECT_VARIANT', { subjectSlug, variant }).then((response) => {
          this.$emit('update')
        })
      } else {
        this.variant.createdAt = this.$moment().format()
        console.log(subjectSlug, variant, question)
        if (this.question.question) {
          this.$store.dispatch('ADD_SUBJECT_VARIANT_QUESTION', { subjectSlug, variant, question }).then((response) => {
            this.$emit('update')
          })
        }
      }
    },
    resetModal () {
      this.variant.title = ''
      this.variant.createdAt = ''
      this.variant.slug = ''
      this.variant.isActive = true
      this.variant.description = ''
      this.variant.questions = []
    },
    showModal () {
      this.$refs['modal'].show()
    },
    hideModal () {
      this.$refs['modal'].hide()
    },
    toggleModal () {
      this.resetModal()
    },
    handleOk (bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
  },
  watch: {
    editQuestion () {
      console.log('edit')
      this.variant.title = this.item.title
      this.variant.createdAt = this.item.createdAt
      this.variant.isActive = this.item.isActive
      this.variant.slug = this.item.slug
      this.variant.description = this.item.description
      this.variant.questions = this.item.questions
      if (this.editQuestion) {
        this.question.question = this.editQuestion.question
        this.question.text = this.editQuestion.text ? this.editQuestion.text : ''
        this.question.answers = this.editQuestion.answers ? this.editQuestion.answers : []
        this.question.answer = this.editQuestion.answer ? this.editQuestion.answer : []
        this.questionIndex = this.editQuestionIndex
      } else {
        this.question.question = ''
        this.question.text = ''
        this.question.answers = []
        this.question.answer = []
        this.questionIndex = null
      }
    },
    item () {
      this.variant.title = this.item.title
      this.variant.createdAt = this.item.createdAt
      this.variant.isActive = this.item.isActive
      this.variant.slug = this.item.slug
      this.variant.description = this.item.description
      this.variant.questions = this.item.questions
    }
  }
}
</script>